import { Component, computed, input, Input, InputSignal, Signal } from '@angular/core';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { CommonModule } from '@angular/common';
import { ApplicationSubjectLabelPipe } from '../../../../../../../pipes/application-subject-label.pipe';
import { environment } from '../../../../../../../../environments/environment';
import {
  DocumentIssuePurposeLabelPipe
} from '../../../../../../../pipes/document-issue-purpose/document-issue-purpose-label.pipe';

@Component({
  selector: 'app-application-data-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule,
    ApplicationSubjectLabelPipe,
    DocumentIssuePurposeLabelPipe
  ],
  templateUrl: './application-data-preview.component.html'
})
export class ApplicationDataPreviewComponent {

  public application = input<ApplicationAppEntityApplicationRead | null>(null);

  public applicationSubmittedTo = environment.applicationSubmittedTo;

  public showResponsiblePerson: Signal<boolean> = computed(() =>
    !!this.application()?.responsiblePersonEmail?.length
    && !!this.application()?.responsiblePersonFirstName?.length
    && !!this.application()?.responsiblePersonLastName?.length
  );

  public showManager: Signal<boolean> = computed(() =>
    !!this.application()?.managerEmail?.length
    && !!this.application()?.managerFirstName?.length
    && !!this.application()?.managerLastName?.length
  );

  public showCorrespondenceAddress: Signal<boolean> = computed(() => this.application()?.documentReceiptMethod?.id === '6b5e71fd-40f7-4333-91d9-ca5451de6309');

  public showLocationUnrelatedDeviceData: Signal<boolean> = computed(() => this.application()?.service?.url === '/umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi');

  public showLocalisationUnrelatedDeviceData: Signal<boolean> = computed(() => this.application()?.service?.url === '/lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi');

  public placeOfFillingDeclarationInfo: Signal<boolean> = computed(() => this.application()?.service?.url === '/deklaracja-o-wysokosci-oplaty-za-gospodarowanie-odpadami-komunalnymi');

}
